import { defineComponent as _defineComponent } from 'vue'
import Edit from '../collections/Edit.vue';

type Props = {
  id?: string;
  title: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null
  },
  setup(__props: any) {



return { __sfc: true,Edit }
}

})